import React from 'react';

const RuntimeContext = React.createContext({});
const { Consumer, Provider } = RuntimeContext;
export { RuntimeContext, Consumer, Provider };
